import { WorkflowRun } from '@digital-twins/shared-types'

import { parseGateQuestions } from './ThreadRunPane/gateArtifacts'

/**
 * Question stems already on the run (gate / draft artifacts). Content language.
 * Empty when the run has no typed questions payload yet.
 */
export function readTwinTestSamplingStems(
  run: WorkflowRun | null,
): Array<string> {
  if (run === null) {
    return []
  }

  for (const step of run.steps) {
    const output = step.outputOverride ?? step.output
    if (!output || output.kind !== 'artifacts') {
      continue
    }

    for (const artifact of output.artifacts) {
      const questions = parseGateQuestions(artifact.body)
      if (!questions || questions.length === 0) {
        continue
      }

      return questions.map((question) => {
        const prompt = question.prompt.trim()
        if (prompt) {
          return prompt
        }

        return (question.title ?? '').trim()
      })
    }
  }

  return []
}
